import React, {useEffect, useState} from 'react';
import './MultiChangeLinks.scss';
import {useDispatch, useSelector} from "react-redux";
import {Popover, Tooltip} from "antd";
import {ChainIcon, ShevronMenuIcon} from "../../../../image";
import {useTranslation} from "react-i18next";
import {GetVideosService, MassActionsVideosService} from "../../../../redux/actions";
import {
	FILTER_SORT_PAGE_TYPES,
	getValueFilters
} from "../../../../modules/Filters/helpers";
import Text from "../../../../modules/Text/Text";
import {Button} from "../../../../modules/Button";
import {Form} from "react-bootstrap";
import DatePickerDropdowns from "../../../ManageData/ManageVideo/DatePickerDropdowns/DatePickerDropdowns";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import {VIDEOS_CONSTS} from "../../../../redux/constants";
import {ApiStatus} from "../../../../utils/constants";


const MultiChangeLinks = ({videoIds, page,changeSelectedIds}) => {
	const {t} = useTranslation();
	const [open, setOpen] = useState(false);
	const [checkedType, setCheckedType] = useState(false);
	const [channelInfo, setChannelInfo] = useState(false);
	const [startDate, setStartDate] = useState(new Date());
	const allFilters = useSelector(state => state.filtersOrSort);
	const allFiltersValue = getValueFilters(allFilters,FILTER_SORT_PAGE_TYPES.MANAGED_VIDEOS);
	const dispatch = useDispatch();

	function handleOpenChange(newOpen) {
		setOpen(newOpen);
	}

	const handleCancelClick = () => {
		setOpen(false);
	}

	const handleApplyClick = async () => {
		try {
			dispatch({
				type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
				payload: ApiStatus.LOADING
			})
			setOpen(false);
			setCheckedType(false);
			setChannelInfo(false);
			await dispatch(MassActionsVideosService({
				video_ids: videoIds,
				is_public: checkedType,
				expiration_time: !channelInfo ? undefined : dayjs(startDate).format('YYYY-MM-DD')
			}));
			changeSelectedIds([])
			await dispatch(GetVideosService({limit: 20, offset: (page - 1) * 20, manage: true, ...allFiltersValue}));
			dispatch({
				type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
				payload: ApiStatus.SUCCESS
			})
		} catch (error) {
			console.error(error);
			dispatch({
				type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
				payload: ApiStatus.ERROR
			})
		}
	}

	const changeDateFormat = (date) => {
		const day = date?.getDate()
		const month = date?.getMonth() + 1
		const year = date?.getFullYear()

		return `${day}/${month}/${year}`
	}
	function toggleCheck() {
		setChannelInfo(!channelInfo)
	}

	function changeTime(date) {
		const dateStart = new Date(date);
		setStartDate(dateStart);

	}

	return (
		<Popover
			arrow={false}
			trigger='click'
			placement="bottomLeft"
			overlayClassName='multi-link'
			onOpenChange={handleOpenChange}
			open={open}
			content={
				<div className="multi-link__container">
					<div className="multi-link__header">
						<Text font="bold" size="f20">{t('profile_link')}</Text>
					</div>
					<div className="multi-link__body">
						<Form className={'link-switch'}>
							<Form.Check
								type="switch"
								id="switch-one"
								label={checkedType ? t('public') : t('non_public')}
								checked={checkedType}
								onChange={(e) => setCheckedType(!checkedType)}
							/>
						</Form>
						{checkedType && <Form className="link-types">
							<Form.Check
								inline
								name="type"
								label={t('indefinitely')}
								type={'radio'}
								checked={!channelInfo}
								onChange={(e) => toggleCheck({
									name: 'participant',
									value: e?.target?.checked,
								})}
							/>
							<Form.Check
								inline
								name="type"
								label={`${t('by_date')} (${t('before')} ${changeDateFormat(startDate)})`}
								type={'radio'}
								checked={channelInfo}
								onChange={(e) => toggleCheck({
									name: 'all',
									value: e?.target?.checked,
								})}
							/>
						</Form>}

						{
							checkedType && channelInfo && <div className={`calendar-wrapper`}>
								<DatePickerDropdowns changeTime={changeTime}
													 date={startDate}/>
								<DatePicker
									selected={startDate}
									onChange={(date) => {
										changeTime(date)
									}}
									startDate={startDate}
									dateFormat="yyyy/MM/dd"
									inline
								/>
							</div>
						}
					</div>
					<div className="filter-links__footer">
						<Button
							text={t('button_cancel')}
							variant="secondary"
							size="xs"
							onClick={handleCancelClick}
						/>
						<Button
							text={t('apply')}
							variant="primary"
							size="xs"
							onClick={handleApplyClick}
						/>
					</div>
				</div>
			}
		>
			<div className={`multi-link__label`}>
				<div className={`multi-link__wrap`}>
					<ChainIcon className="multi-link--chain-icon"/>
					<Text font="book" size="f14" color="#1ABB78">{t('manage_links')}</Text>
					<ShevronMenuIcon className={`multi-link__label--arrow ${open ? 'open' : ''}`}/>
				</div>
			</div>
		</Popover>
	);
};

export default MultiChangeLinks;